import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Container } from './styles';

export default function AlertBox({ content, isSuccess }) {
  return ReactDOM.createPortal(
    (
      <Container isSuccess={isSuccess}>
        <span>
          {content}
        </span>
      </Container>
    ),
    document.getElementById('alert-box-root'),
  );
}

AlertBox.propTypes = {
  content: PropTypes.string.isRequired,
  isSuccess: PropTypes.bool,
};

AlertBox.defaultProps = {
  isSuccess: true,
};
